export const getDiffMinutes = (time1, time2) => {
  const [h1, m1] = time1.split(":").map(Number);
  const [h2, m2] = time2.split(":").map(Number);

  const d1 = new Date();
  d1.setHours(h1, m1, 0, 0);

  const d2 = new Date();
  d2.setHours(h2, m2, 0, 0);

  return Math.floor((d1 - d2) / (1000 * 60));
};
